import React, {useState} from 'react';
import {Col, Row} from "reactstrap";
import FormWithActions from "../Elements/FormWithActions/FormWithActions";
import FormGroupRowSelect from "../Elements/FormGroupRowSelect";
import FormGroupRowTextList from "../Elements/FormGroupRowTextList";
import {validEmail} from "../services";

const SenderOnboardingMailForm = ({senderOnboarding, onAction}) => {
    const [language, setLanguage] = useState(senderOnboarding.language);
    const [toEmails, setToEmails] = useState([senderOnboarding.email]);

    const handleAction = () => {
        return onAction(language, toEmails);
    };

    let disableSubmitReason = '';
    if (toEmails.some(email => !validEmail(email))) {
        disableSubmitReason = 'All email addresses need to be valid.';
    }

    return (
        <>
            <Row>
                <Col>
                    <h1 className="mb-5">
                        Send buckaroo e-mail
                    </h1>
                </Col>
            </Row>
            <FormWithActions onAction={handleAction} submitButton="Send buckaroo e-mail" disableSubmitReason={disableSubmitReason}>
                <FormGroupRowSelect
                    label="Language"
                    value={language}
                    onChange={setLanguage}
                    options={[
                        {value: 'nl' ,label: 'NL'},
                        {value: 'fr' ,label: 'FR'},
                        {value: 'en' ,label: 'EN'},
                    ]}
                />
                <FormGroupRowTextList
                    label="E-mails"
                    value={toEmails}
                    onChange={setToEmails}
                />
            </FormWithActions>
        </>
    );
};

export default SenderOnboardingMailForm;